// import ReactGA from "react-ga4";

// const GA_ID = process.env.REACT_APP_GA_ID;

// export function initGA() {
//   if (GA_ID) {
//     ReactGA.initialize(GA_ID);
//   }
// }

// export function trackPageView(path: string) {
//   if (!GA_ID) return;

//   ReactGA.send({
//     hitType: "pageview",
//     page: path,
//   });
// }

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

const GA_ID = process.env.REACT_APP_GA_ID || "";

/**
 * Validate GA Measurement ID format
 */
function isValidGAId(id: string): boolean {
  return /^G-[A-Z0-9]+$/i.test(id);
}

const GA_ENABLED = isValidGAId(GA_ID);

let initialized = false;

/**
 * Ensure dataLayer exists and push a gtag-style call so GA processes it when the script loads.
 * Used when gtag is not yet available (async script still loading).
 */
function pushToDataLayer(...args: any[]) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

/**
 * Initialize GA safely. If gtag is not yet loaded (async script), we push config
 * to dataLayer so GA will initialize when the script loads.
 */

export function initGA() {
  if (!GA_ENABLED) {
    console.info("[GA] Disabled — invalid or missing GA ID");
    return;
  }

  if (initialized) return;

  const config = {
    send_page_view: false, // SPA — we handle manually
    anonymize_ip: true,
  };

  if (typeof window.gtag === "function") {
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, config);
  } else {
    // Script still loading: queue so gtag.js will process when it loads
    pushToDataLayer("js", new Date());
    pushToDataLayer("config", GA_ID, config);
  }

  initialized = true;
  console.info("[GA] Initialized");
}

function sendEvent(name: string, params: Record<string, any> = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  } else {
    pushToDataLayer("event", name, params);
  }
}

/**
 * Track page view
 */
export function trackPageView(path: string) {
  if (!GA_ENABLED || !initialized) return;

  sendEvent("page_view", { page_path: path });
}

/**
 * Track custom event
 */
export function trackEvent(name: string, params: Record<string, any> = {}) {
  if (!GA_ENABLED || !initialized) return;

  sendEvent(name, params);
}
